import { ReactNode, useState } from 'react';
import { Tag } from '../ui/atoms/Tag';

interface ComingSoonIntegrationCardProps {
  name: string;
  description: string;
  /** Optional logo URL. If it fails to load, falls back to the monogram tile. */
  logoUrl?: string;
  /** Two-letter monogram for the fallback tile. */
  monogram?: string;
  /** Optional category tag (e.g., "ATS", "HRIS"). */
  category?: ReactNode;
}

export const ComingSoonIntegrationCard = ({
  name,
  description,
  logoUrl,
  monogram,
  category,
}: ComingSoonIntegrationCardProps) => {
  const [logoFailed, setLogoFailed] = useState(false);
  const showLogo = logoUrl && !logoFailed;

  return (
    <div className="rounded-xl border border-light-lila/40 bg-light p-5 flex flex-col h-full">
      <div className="flex items-center gap-3 mb-3">
        {showLogo ? (
          <img
            src={logoUrl}
            alt=""
            onError={() => setLogoFailed(true)}
            className="h-10 w-10 rounded-lg object-contain bg-white shrink-0"
          />
        ) : (
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-dark-invirtus-soft text-dark-invirtus shrink-0">
            <span className="text-xs font-bold font-heading tracking-tight">
              {monogram ?? name.slice(0, 2).toUpperCase()}
            </span>
          </div>
        )}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-sm font-semibold text-dark-invirtus font-heading">{name}</span>
            <Tag intent="secondary" variant="subtle" className="uppercase">
              Soon
            </Tag>
          </div>
          {category && (
            <div className="text-[11px] text-dark-invirtus/50 font-body mt-0.5">{category}</div>
          )}
        </div>
      </div>
      <p className="text-xs text-dark-invirtus/60 font-body leading-relaxed flex-1">{description}</p>
    </div>
  );
};
